import React from "react"
import styles from "./header.module.scss"

interface Props {
  title: string
  titleHighlight: string
  highlightColour: string
}

export default function Header(props: Props) {
  return (
    <header className={styles.header}>
      <h1 className="display1">
        {props.title}
        <br />
        <span style={{ color: props.highlightColour }}>
          {props.titleHighlight}
        </span>
      </h1>
    </header>
  )
}
